import {HttpClient, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {deserialize} from '@app/serializable';
import {Tag} from '@app/tag/models';
import {ReplaySubject} from 'rxjs';
import {map} from 'rxjs/operators';

export class Badge {
    id: number;
    tag: Tag;
    image: string;
}

@Injectable({
    providedIn: 'root',
})
export class BadgeService {
    public badges: ReplaySubject<Badge[]>;
    private cache: Badge[];

    constructor(private http: HttpClient) {
        this.badges = new ReplaySubject<Badge[]>();
        this.cache = [];

        const url = '/api/badge/';
        this.http
            .get<Badge[]>(url)
            .pipe(
                map((badges) => {
                    return badges.map((item) => {
                        const badge = deserialize(Badge, item);
                        badge.tag = deserialize(Tag, badge.tag);
                        return badge;
                    });
                }),
            )
            .subscribe((badges) => {
                this.cache = badges;
                this.badges.next(this.cache);
            });
    }

    update(tagId: string, image: File = null) {
        const url = '/api/badge/';

        const formdata = new FormData();
        formdata.append('tag', tagId);
        if (image !== null) {
            formdata.append('image', image, image.name);
        }
        const req = new HttpRequest('POST', url, formdata);
        this.http.request(req).subscribe((res) => {
            const result = res as any;
            if (!result.body) {
                return;
            }
            const badge = deserialize(Badge, result.body);
            badge.tag = deserialize(Tag, badge.tag);
            let found = false;
            for (let i = 0; i < this.cache.length; i++) {
                if (this.cache[i].id === badge.id) {
                    this.cache[i] = badge;
                    found = true;
                    break;
                }
            }
            if (!found) {
                this.cache.push(badge);
            }
            this.badges.next(this.cache);
        });
    }

    delete(id: number) {
        const url = `/api/badge/${id}/`;
        const options = {
            withCredentials: true,
        };

        this.http.delete(url, options).subscribe(() => {
            for (let i = 0; i < this.cache.length; i++) {
                if (this.cache[i].id === id) {
                    this.cache.splice(i, 1);
                    break;
                }
            }
            this.badges.next(this.cache);
        });
    }

    getByTag(tagId: string) {
        for (let i = 0; i < this.cache.length; i++) {
            if (this.cache[i].tag.id === tagId) {
                return this.cache[i];
            }
        }

        return null;
    }
}
